/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent, Fragment } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import PlacesAutocomplete from "react-places-autocomplete";
import classNames from "classnames";
import { connect } from "react-redux";
import {
  lookupAsset,
  saveAsset,
  saveAssetNotFoundLog
} from "../../../actions/asset/assetAction";
import LookupResult from "./LookupResult";
import searchImage from "../../../img/search_icon.png";
import { isFetching, isSuccess } from "../../../reducers/reducerUtils";

class AssetLookup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      foundAssets: [],
      hasSearched: false,
      assetNotFound: false,
      loading: false
    };
  }

  handleChange = address => {
    this.setState({ address });
  };

  searchAsset = e => {
    e.preventDefault();

    const { address } = this.state;
    if (address) {
      this.setState({ hasSearched: false, loading: true, foundAssets: [] });
      this.props.lookupAsset(address);
    }
  };

  importAsset = asset => {
    this.props.saveAsset(asset);
  };

  resetFields = () => {
    this.setState({
      loading: false,
      hasSearched: false,
      foundAssets: [],
      address: ""
    });
    this.props.toggleModal();
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { assetLookup } = nextProps;

    if (prevState.loading && !isFetching(assetLookup)) {
      if (isSuccess(assetLookup)) {
        let assets = assetLookup.data.data;
        return {
          foundAssets: assets,
          hasSearched: true,
          loading: false,
          assetNotFound: assets.length === 0
        };
      }
    }
    return null;
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.assetNotFound) {
      this.setState({ assetNotFound: false }, () => {
        this.props.saveAssetNotFoundLog(this.state.address);
      });
    }
  };

  render() {
    const { foundAssets, hasSearched, loading } = this.state;
    let asset = {};
    if (foundAssets.length === 0) {
      asset.imageUrl = "";
      asset.address = this.state.address;
      asset.apn = "CLICK TO IMPORT MANUALLY";
      asset.co_ordinates = [0, 0];
      asset.asset_name = this.state.address
        .split(" ")
        .slice(1, 3)
        .join(" ");
    }
    const { modalOpen } = this.props;
    const btnTxt = loading ? "Searching..." : "Search Asset";
    return (
      <Modal
        isOpen={modalOpen}
        contentClassName={"asset-lookup"}
        size={"xl"}
        unmountonclose={"true"}
      >
        <ModalHeader toggle={this.resetFields}>Asset Lookup</ModalHeader>
        <ModalBody>
          <p>
            BetterCapital get public asset data using, Rets.ly © Rets.ly, Inc.,
            2006-2019. Use is subject to terms of use.
          </p>

          <div className="assetsearch">
            <form onSubmit={this.searchAsset}>
              <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange}
                searchOptions={{ componentRestrictions: { country: "us" } }}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                  <Fragment>
                    <div className="form-group">
                      <input
                        type="text"
                        {...getInputProps({
                          placeholder: "Enter your property address",
                          className: "form-control"
                        })}
                      />
                      <a
                        href="#"
                        className="lookasset_btn"
                        onClick={this.searchAsset}
                      >
                        <img
                          src={searchImage}
                          className="mr-0 mr-md-2"
                          alt=""
                        />
                        <span> {btnTxt}</span>
                      </a>
                    </div>
                    {suggestions.length > 0 && (
                      <div className="autocomplete-suggestion-container ">
                        {suggestions.map(suggestion => {
                          const className = classNames(
                            "autocomplete__suggestion-item",
                            {
                              "autocomplete__suggestion-item--active":
                                suggestion.active
                            }
                          );

                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className
                              })}
                            >
                              <strong>
                                {suggestion.formattedSuggestion.mainText}
                              </strong>{" "}
                              <small>
                                {suggestion.formattedSuggestion.secondaryText}
                              </small>
                            </div>
                          );
                        })}
                        <div className="autocomplete__dropdown-footer">
                          <div>
                            <img
                              src={require("../../../img/powered_by_google_default.png")}
                              className="autocomplete__dropdown-footer-image"
                              alt="powered by Google"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </Fragment>
                )}
              </PlacesAutocomplete>
            </form>
          </div>
          {hasSearched && (
            <div className="asset-searchlist">
              <h4>Found {foundAssets.length} properties</h4>
              <div className="row">
                {foundAssets.length === 0 && (
                  <LookupResult
                    asset={asset}
                    importAsset={this.importAsset}
                    toggleMainModal={this.resetFields}
                  />
                )}
                {foundAssets.map((r, i) => (
                  <LookupResult
                    key={i}
                    asset={r}
                    importAsset={this.importAsset}
                    toggleMainModal={this.resetFields}
                  />
                ))}
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  assetLookup: state.asset.assetLookup
});

const mapDispatchToProps = dispatch => ({
  lookupAsset: address => lookupAsset(address, dispatch),
  saveAsset: asset => saveAsset(asset, dispatch),
  saveAssetNotFoundLog: address => saveAssetNotFoundLog(address, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetLookup);
